<template>
  <div id="crumbs" @mouseenter="openPresetMenu" @mouseleave="closePresetMenu">
    <div class="btn-group btn-group-sm" role="group" aria-label="First group">
      <button
        @mouseenter="openSubWSecond('dp')"
        @mouseleave="closeSubWSecond('dp')"
        type="button"
        class="btn btn-dp"
      >
        <!--        @click="openSubW('clientsdep', 'dp')"-->

        <!--        :class="{-->
        <!--        'greyed-out':-->
        <!--        selectedMainTab === 'bn' || greyOutTag('dp', selectedMainTab)-->
        <!--        }"-->
        <!--        <span-->
        <!--          >{{ statsOverall == 0 ? "DP" : kFormatter(statsOverall)-->
        <!--          }}{{ totalSum > 0 && statsOverall != 0 ? "/" + totalSum : "" }}</span-->
        <!--        >-->
        <div
          v-tooltip.right="{
            content: `
            ${getCR(statsOverall, stats)} |
            Amount of deposits divided by amount of clients`
          }"
        >
          <span
            v-if="kFormatter(statsOverall) === 0 && kFormatter(stats) === 0"
          >
            DP
          </span>
          <span
            v-else
            v-tooltip.top="{
              content: ``
            }"
            >{{ kFormatter(stats) + "/" + kFormatter(statsOverall) }}</span
          >
        </div>
        <div class="bb-sub-menu" v-if="checkSubMenuMode('dp')">
          <div
            class="bb-sub-menu-ms"
            @click.stop="openMsW('dp')"
            v-tooltip="{ content: `Open multi-select` }"
          >
            <div class="dp-color bb-item">
              <i class="fas fa-bars"></i>
            </div>
            <div class="fake-column dp-color"></div>
            <!--            <div class="bb-tooltip ms-tt" v-if="tooltip.ms">Multi select</div>-->
          </div>
          <div
            class="bb-sub-menu-reset"
            @click.stop="closeResetBtnW('dp')"
            v-tooltip="{ content: `Reset` }"
          >
            <div class="dp-color bb-item">
              <i class="fas fa-times"></i>
              <!--              <div class="bb-tooltip" v-if="tooltip.rs">Reset</div>-->
            </div>
            <div class="fake-column dp-color"></div>
          </div>
        </div>
        <div class="bb-sub-menu" v-if="checkIfSecondView('dp')">
          <div
            v-if="checkNumbersOfCalendarsSelected() === 1"
            class="bb-sub-menu-ms merged"
            @click.stop="mergeAllDates('dp', 'clientsdep', shortCutsToBlocks)"
            v-tooltip="{
              content: `Use the same selected dates with this new selection`
            }"
          >
            <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

            <div class="dp-color bb-item">
              <div class="first-circle-tot"></div>
              <div class="second-circle-tot"></div>
              <div class="fake-column-tot dp-color"></div>
            </div>
          </div>
          <div
            class="bb-sub-menu-reset"
            @click.stop="filterSingleTag('clientsdep', 'dp')"
            v-tooltip="{ content: `Disregard previous selections` }"
          >
            <div class="dp-color bb-item">
              <div class="first-circle first-circle-right"></div>
              <div class="second-circle second-circle-right"></div>
            </div>
            <div class="fake-column dp-color"></div>
          </div>
          <div
            class="bb-sub-menu-ms"
            @click.stop="filterMultipleTags('clientsdep', 'dp')"
            v-tooltip="{ content: `Productivity` }"
          >
            <div class="dp-color bb-item">
              <div class="first-circle"></div>
              <div class="second-circle "></div>
              <div class="fake-column dp-color"></div>
            </div>
          </div>
        </div>
        <div class="bb-title-wrapper upper-title">
          <span class="">Dep</span>
        </div>
        <div
          class="tags-dropdown"
          v-if="
            openTagDropdown &&
              mouseOver &&
              !checkSubMenuMode('dp') &&
              !checkIfSecondView('dp')
          "
        >
          <!--        <div class="tags-dropdown" v-if="false">-->
          <TagsDropdown
            :btnColors="btnColors"
            @presetTrigger="emitPresetTrigger"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";

import { mapState } from "vuex";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "DepositsBreadcrumbButton",
  components: {
    TagsDropdown
  },
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    resetDpButtons: {
      type: Boolean
    },
    resetCcdclButtons: {
      type: Boolean
    },
    resetCLButtons: {
      type: Boolean
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    disabledDeposit: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabledCcDecline: {
      type: Boolean,
      required: false,
      default: () => false
    },
    stats: {
      type: Number,
      required: false
    },
    statsOverall: {
      type: Number,
      required: false
    },
    statsOverallCc: {
      type: Number,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    switchPlaces: {
      type: Boolean,
      required: false,
      default: false
    },
    queryObject: {
      type: Object
    }
  },
  data() {
    return {
      calendarForPreset: "DEP",
      btnColors: {
        backgroundColor: "#c152f1",
        color: "white"
      },
      mouseOver: false,
      openTagDropdown: false,
      showPopup: false,
      clicked: false,
      slideBtn: {
        cl: false,
        dp: false,
        ccd: false
      },
      resetBtn: {
        cl: false,
        dp: false,
        ccd: false
      },
      secondClick: {
        cl: false,
        dp: false,
        ccd: false
      },
      tooltip: {
        ms: false,
        rs: false,
        pr: false,
        mr: false,
        ns: false
      },
      totalSum: ""
    };
  },
  watch: {
    // totalSumForCrumbBtn: function() {
    //   this.totalSum = this.totalSumForCrumbBtn;
    // }
  },
  computed: {
    ...mapState("clients", ["totalSumForCrumbBtn", "shortCutsToBlocks"]),

    btnStyles() {
      return {
        "--bg-color": this.disabledDeposit ? "#546e7a" : this.bgColor,
        "--hover-on-disable":
          this.disabledDeposit || this.disabledCcDecline || this.disabled
            ? "-3px"
            : "0px",
        "--font-weight": this.disabledDeposit ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },

    btnCcDeclineStyles() {
      return {
        "--cc-decline-bg-color": this.disabledCcDecline ? "#546e7a" : "#4a148c",
        // "--hover-on-disable": this.disabledCcDecline ? "-3px" : "0px",
        "--font-weight": this.disabledCcDecline ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnDepositsStyles() {
      return {
        "--deposits-bg-color": this.disabled ? "#546e7a" : "#7b1fa2",
        // "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  mixins: [breadButtonsFunctionsUtil, calendarCheck],

  methods: {
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("clientsdep", "dp");
      }
    },
    // getCR(statsOv, stats){
    //   if(statsOv > 0 && stats > 0){
    //     return (statsOv/stats).toFixed(2)
    //   } else{
    //     return ''
    //   }
    // },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        return 0;
      }
    }
  },
  // created() {
  //   $(document).ready(function() {
  //     $('[data-toggle="tooltip"]').tooltip();
  //   });
  // },
  mounted() {
    // $('[data-toggle="tooltip"]').tooltip();

    $(document).ready(function() {
      $("body").tooltip({ selector: "[data-toggle=tooltip]" });
      // $("body").tooltip({ container: 'body' })

      // $('[data-toggle="tooltip"]').tooltip();
      $(".round").click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(".arrow").toggleClass("bounceAlpha");
      });
    });
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #ae3ede;
$btnColorCL: #7b1fa2;
/*$btnColorCCD: #546e7a;*/
$btnColorCCD: black;
$btnColorChild: #009147;
$color: var(--bg-color);
$depositColor: var(--deposits-bg-color);
$ccDeclineColor: var(--cc-decline-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: #ae3ede;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-weight: 500;
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.tag-table {
  position: absolute;
  bottom: 20px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  font-size: 13px;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
}

.table {
  margin-bottom: 0;
}

.dot-left {
  height: 20px;
  width: 25px;
  border: 1px solid $depositColor;
  border-radius: 5px;

  color: $depositColor;
  /*border-radius: 50%;*/
  bottom: 20px;
  left: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 13px;
}

.dot-right {
  height: 20px;
  width: 25px;
  border: 1px solid #009147;
  border-radius: 5px;

  color: #009147;
  /*border-radius: 50%;*/
  bottom: 20px;
  right: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 13px;
}

.btn-dp {
  font-size: 10px;
  color: #ffffff;
  background-color: #c152f1;
  //border-color: #c152f1;
  transition: all 0.2s ease-in;
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
  position: relative;
}

.btn-dp:hover,
.btn-dp:focus,
.btn-dp:active,
.btn-dp.active,
.open .dropdown-toggle.btn-sc {
  outline: none;
  z-index: 0 !important;
}

.btn-dp:focus,
.btn-dp:active,
.btn-dp.active {
  /*-moz-box-shadow: inset 0 0 5px 5px #fa8100;*/
  /*-webkit-box-shadow: inset 0 0 5px 5px#fa8100;*/
  /*box-shadow: inset 0 0 5px 5px #fa8100;*/
}

.btn-dp:nth-of-type(2) {
  /*CCD*/
  background-color: $btnColorCCD;
  border-color: $btnColorCCD;
  /*<!--border-bottom-color: $btnColor;-->*/
  /*<!--border-top-color: $btnColor;-->*/
}

.btn-dp:nth-of-type(3) {
  /**/
  background-color: $btnColorCCD;
  border-color: $btnColorCCD;
  /*<!--border-bottom-color: $btnColor;-->*/
  /*<!--border-top-color: $btnColor;-->*/
}

.btn-dp:nth-of-type(4) {
  /* Auto Missed calls*/
  background-color: #c62828;
  border-color: #c62828;
  /*<!--border-bottom-color: $btnColor;-->*/
  /*<!--border-top-color: $btnColor;-->*/
}

.btn-dp:nth-of-type(5) {
  background-color: #af4448;
  border-color: #af4448;
  /*<!--border-bottom-color: $btnColor;-->*/
  /*<!--border-top-color: $btnColor;-->*/
  /*<!--border-right-color: $btnColor;-->*/
}

.slide-btn {
  position: absolute;
  top: 24px;
  background-color: inherit;
  width: 105%;
  left: -1px;
  border-radius: 0px 0px 30px 0px;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  /*transform: scale(1.3);*/
  color: red;
}

.arrow {
  position: absolute;
  top: 13px;
  left: -3px;
  /*transform: translate(50%,50%);*/
  transform: rotate(90deg);
}

.arrow span {
  display: block;
  width: 6px;
  height: 6px;
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  transform: rotate(45deg);
  margin: -10px;
  animation: animate 2s infinite;
}

.arrow span:nth-child(2) {
  animation-delay: -0.2s;
}

.arrow span:nth-child(3) {
  animation-delay: -0.4s;
}

@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(0px, 0px);
  }
}

#crumbs .btn-group-sm {
  display: flex;
}

.btn-dp:hover {
  transform: scale(1.1);
}

span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 10px;
  font-size: 8px;
}

div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 100%;
  top: 25px;
  left: 0px;
  text-align: center;
}

.upper-title {
  text-transform: uppercase;
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.cl-color {
  background-color: $btnColorCL;
}

.ccd-color {
  background-color: $btnColorCCD;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.dp-color {
  background-color: $btnColor;
}

.btn-dp:hover {
  /*filter: brightness(90%);*/
}

.btn-dp:hover span {
  /*filter: brightness(110%);*/
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.btn-ccd {
  background-color: black;
}

.btn-group {
  //z-index: 0 !important;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}

.btn-dp:hover {
  //background-color: #0a0a0a;
  outline: none;
  z-index: 1 !important;
  cursor: default;
}
</style>
